export default __webpack_public_path__ + "static/media/school-account.cd71294e.svg";